export var SVGIcons;
(function (SVGIcons) {
    SVGIcons["BOTTOM_BAR_BUY"] = "bottom-bar/buy";
    SVGIcons["BOTTOM_BAR_ECOSYSTEM"] = "bottom-bar/ecosystem";
    SVGIcons["BOTTOM_BAR_SEND"] = "bottom-bar/send";
    SVGIcons["BOTTOM_BAR_SWAPS"] = "bottom-bar/swaps";
    SVGIcons["BUY_BINANCE"] = "buy/binance";
    SVGIcons["BUY_GATEIO"] = "buy/gateio";
    SVGIcons["BUY_HUOBI"] = "buy/huobi";
    SVGIcons["BUY_IONOMY"] = "buy/ionomy";
    SVGIcons["BUY_MEXC"] = "buy/mexc";
    SVGIcons["BUY_HTX"] = "buy/htx";
    SVGIcons["BUY_TRANSAK"] = "buy/transak";
    SVGIcons["BUY_UPBIT"] = "buy/upbit";
    SVGIcons["CHECKBOX_CHECKED"] = "checkbox/checked";
    SVGIcons["FAVORITE_ACCOUNTS_EDIT"] = "favorite-accounts/edit";
    SVGIcons["FAVORITE_ACCOUNTS_DELETE"] = "favorite-accounts/delete";
    SVGIcons["FAVORITE_ACCOUNTS_CANCEL"] = "favorite-accounts/cancel";
    SVGIcons["FAVORITE_ACCOUNTS_SAVE"] = "favorite-accounts/save";
    SVGIcons["GLOBAL_ARROW"] = "global/arrow";
    SVGIcons["GLOBAL_DELETE"] = "global/delete";
    SVGIcons["GLOBAL_ERROR"] = "global/error";
    SVGIcons["GLOBAL_ADD_CIRCLE"] = "global/add-circle";
    SVGIcons["GLOBAL_EXPAND_COLLAPSE"] = "global/expand-collapse";
    SVGIcons["GOVERNANCE_MY_WITNESS_DEACTIVATED"] = "governance/my-witness/deactivated";
    SVGIcons["GOVERNANCE_WITNESS_LINK"] = "governance/witness-link";
    SVGIcons["GOVERNANCE_WITNESS_UPVOTE_DOWNVOTE"] = "governance/update-downvote-witness";
    SVGIcons["GOVERNANCE_PROPOSAL_BUDGET"] = "governance/proposal/budget";
    SVGIcons["GOVERNANCE_PROPOSAL_DURATION"] = "governance/proposal/duration";
    SVGIcons["GOVERNANCE_PROPOSAL_EXPAND_COLLAPSE"] = "governance/proposal/expand-collapse";
    SVGIcons["GOVERNANCE_PROPOSAL_UPVOTE_VALUE"] = "governance/proposal/upvote-value";
    SVGIcons["GOVERNANCE_PROPOSAL_UPVOTE"] = "governance/proposal/upvote";
    SVGIcons["STEEM_ENGINE"] = "wallet/steem-engine";
    SVGIcons["WALLET_SETTINGS"] = "wallet/settings";
    SVGIcons["WALLET_SEARCH"] = "wallet/search";
    SVGIcons["INPUT_SHOW"] = "input/show";
    SVGIcons["INPUT_HIDE"] = "input/hide";
    SVGIcons["INPUT_MAX"] = "input/max";
    SVGIcons["INPUT_ENCRYPT"] = "input/encrypt";
    SVGIcons["INPUT_DECRYPT"] = "input/decrypt";
    SVGIcons["INPUT_SEARCH"] = "input/search";
    SVGIcons["INPUT_AT"] = "input/at";
    SVGIcons["INPUT_CLEAR"] = "input/clear";
    SVGIcons["KEYCHAIN_LOGO_SPLASHSCREEN"] = "splashscreen/keychain-logo";
    SVGIcons["KEYCHAIN_LOGO_ROUND"] = "keychain-round-logo";
    SVGIcons["KEYCHAIN_LOGO_ROUND_SMALL"] = "keychain-round-logo-small";
    SVGIcons["KEYCHAIN_FULL_LOGO"] = "keychain-full-logo";
    SVGIcons["MENU_BUTTON"] = "top-bar/menu-button";
    SVGIcons["MENU_ABOUT"] = "menu/about";
    SVGIcons["MENU_THEME_DARK"] = "menu/theme/dark-theme";
    SVGIcons["MENU_THEME_LIGHT"] = "menu/theme/light-theme";
    SVGIcons["MENU_ACCOUNTS"] = "menu/accounts";
    SVGIcons["MENU_ACCOUNTS_ADD_ACCOUNT"] = "menu/accounts/add-account";
    SVGIcons["MENU_ACCOUNTS_CREATE_ACCOUNT"] = "menu/accounts/create-account";
    SVGIcons["MENU_ACCOUNTS_EXPORT"] = "menu/accounts/export";
    SVGIcons["MENU_ACCOUNTS_MANAGE_ACCOUNTS"] = "menu/accounts/manage-accounts";
    SVGIcons["MENU_ACCOUNTS_MANAGE_AUTHORITIES"] = "menu/accounts/manage-authorities";
    SVGIcons["MENU_ADVANCED_SETTINGS"] = "menu/advanced-settings";
    SVGIcons["MENU_ADVANCED_SETTINGS_ANALYTICS"] = "menu/advanced-settings/analytics";
    SVGIcons["MENU_ADVANCED_SETTINGS_AUTO_LOCK"] = "menu/advanced-settings/auto-lock";
    SVGIcons["MENU_ADVANCED_SETTINGS_CHANGE_PASSWORD"] = "menu/advanced-settings/change-password";
    SVGIcons["MENU_ADVANCED_SETTINGS_CLEAR_ALL"] = "menu/advanced-settings/clear-all";
    SVGIcons["MENU_ADVANCED_SETTINGS_IMPORT_EXPORT"] = "menu/advanced-settings/import-export-settings";
    SVGIcons["MENU_ADVANCED_SETTINGS_KEYCHAINIFY"] = "menu/advanced-settings/keychainify";
    SVGIcons["MENU_ADVANCED_SETTINGS_RPC_NODE"] = "menu/advanced-settings/rpc-nodes";
    SVGIcons["MENU_ADVANCED_SETTINGS_IMPORT_SETTINGS"] = "menu/advanced-settings/import-settings";
    SVGIcons["MENU_ADVANCED_SETTINGS_EXPORT_SETTINGS"] = "menu/advanced-settings/export-settings";
    SVGIcons["MENU_TOKENS"] = "menu/tokens";
    SVGIcons["MENU_GOVERNANCE"] = "menu/governance";
    SVGIcons["MENU_LOGOUT"] = "menu/logout";
    SVGIcons["MENU_PLUGINS"] = "menu/plugins";
    SVGIcons["MENU_HELP"] = "menu/help";
    SVGIcons["MENU_SUPPORT"] = "menu/help/support";
    SVGIcons["MENU_TUTORIAL"] = "menu/help/tutorial";
    SVGIcons["MENU_USER_PREFERENCES_DETACH_EXTENSION"] = "menu/user-preferences/detach";
    SVGIcons["MENU_USER_PREFERENCES"] = "menu/user-preferences";
    SVGIcons["MENU_USER_PREFERENCES_OPERATIONS"] = "menu/user-preferences/operations";
    SVGIcons["MENU_USER_PREFERENCES_AUTOMATED_TASKS"] = "menu/user-preferences/automated-tasks";
    SVGIcons["MENU_USER_PREFERENCES_FAVORITE_ACCOUNTS"] = "menu/user-preferences/favorite-accounts";
    SVGIcons["MENU_USER_PREFERENCES_THEME"] = "menu/user-preferences/theme";
    SVGIcons["MENU_USER_PREFERENCES_NOTIFICATIONS"] = "menu/user-preferences/notifications";
    SVGIcons["MENU_USER_PREFERENCES_MULTISIG"] = "menu/user-preferences/accounts-multisig";
    SVGIcons["MENU_BOTTOM_BAR_DISCORD"] = "menu/bottom-bar/discord";
    SVGIcons["MENU_BOTTOM_BAR_STEEM"] = "menu/bottom-bar/steem";
    SVGIcons["MENU_BOTTOM_BAR_TWITTER"] = "menu/bottom-bar/twitter";
    SVGIcons["MENU_RPC_ADD_BUTTON"] = "menu/rpc/add-button";
    SVGIcons["MENU_RPC_CLOSE_BUTTON"] = "menu/rpc/close-button";
    SVGIcons["MENU_RPC_SAVE_BUTTON"] = "menu/rpc/save-rpc-button";
    SVGIcons["MESSAGE_ERROR"] = "message/error";
    SVGIcons["MESSAGE_WARNING"] = "message/warning";
    SVGIcons["MESSAGE_SUCCESS"] = "message/success";
    SVGIcons["NOTIFICATIONS_ADD"] = "notifications/add";
    SVGIcons["PORTOLIO"] = "portfolio/portfolio";
    SVGIcons["RESOURCE_ITEM_MANA"] = "resources/mana";
    SVGIcons["RESOURCE_ITEM_RC"] = "resources/rc";
    SVGIcons["RESOURCE_ITEM_SAVINGS"] = "resources/savings";
    SVGIcons["RESOURCE_ITEM_WALLET"] = "resources/wallet";
    SVGIcons["RESOURCE_ITEM_DELEGATION_INCOMING"] = "resources/delegation-incoming";
    SVGIcons["RESOURCE_ITEM_DELEGATION_OUTGOING"] = "resources/delegation-outgoing";
    SVGIcons["TOP_BAR_BACK_BTN"] = "top-bar/back-button";
    SVGIcons["TOP_BAR_CLAIM_REWARDS_BTN"] = "top-bar/claim-rewards-button";
    SVGIcons["TOP_BAR_CLAIM_ALL_REWARDS_BTN"] = "top-bar/claim-all-rewards-button";
    SVGIcons["TOP_BAR_CLOSE_BTN"] = "top-bar/close-button";
    SVGIcons["TOP_BAR_KEYCHAIN_LOGO"] = "top-bar/keychain-logo";
    SVGIcons["TOP_BAR_NOTIFICATION_BUTTON"] = "top-bar/notification-button";
    SVGIcons["SELECT_ARROW_DOWN"] = "select/arrow-down";
    SVGIcons["SELECT_ARROW_UP"] = "select/arrow-up";
    SVGIcons["SELECT_ACTIVE"] = "select/active";
    SVGIcons["SELECT_COPY"] = "select/copy";
    SVGIcons["SELECT_DRAG"] = "select/drag";
    SVGIcons["SELECT_DELETE"] = "select/delete";
    SVGIcons["SWAPS_SWITCH"] = "swaps/swap-switch";
    SVGIcons["SWAPS_HISTORY"] = "swaps/history";
    SVGIcons["SWAPS_ITEM"] = "swaps/swap-item-icon";
    SVGIcons["SWAPS_BETWEEN"] = "swaps/swap-between";
    SVGIcons["SWAPS_EXPAND"] = "swaps/expand";
    SVGIcons["SWAPS_ESTIMATE_REFRESH"] = "swaps/estimate-refresh";
    SVGIcons["SWAPS_HISTORY_REFRESH"] = "swaps/history-refresh";
    SVGIcons["SWAPS_STATUS_PROCESSING"] = "swaps/swap-status/processing";
    SVGIcons["SWAPS_STATUS_FINISHED"] = "swaps/swap-status/finished";
    SVGIcons["SWAPS_STATUS_CANCELED"] = "swaps/swap-status/canceled";
    SVGIcons["WALLET_SBD_LOGO"] = "wallet/sbd-logo";
    SVGIcons["WALLET_STEEM_LOGO"] = "wallet/steem-logo";
    SVGIcons["WALLET_STEEM_LOGO_SMALL"] = "wallet/steem-logo-small";
    SVGIcons["WALLET_SP_LOGO"] = "wallet/sp-logo";
    SVGIcons["WALLET_TIME_LOGO"] = "wallet/time-logo";
    SVGIcons["WALLET_TIME_LOGO_SMALL"] = "wallet/time-logo-small";
    SVGIcons["WALLET_HP_LOGO"] = "wallet/hp-logo";
    SVGIcons["WALLET_HBD_LOGO"] = "wallet/hbd-logo";
    SVGIcons["WALLET_HIVE_LOGO"] = "wallet/hive-logo";
    SVGIcons["WALLET_HIVE_LOGO_SMALL"] = "wallet/hive-logo-small";
    SVGIcons["WALLET_BP_LOGO"] = "wallet/bp-logo";
    SVGIcons["WALLET_BLURT_LOGO"] = "wallet/blurt-logo";
    SVGIcons["WALLET_BLURT_LOGO_SMALL"] = "wallet/blurt-logo-small";
    SVGIcons["WALLET_POWER_DOWN"] = "wallet/hp/power-down";
    SVGIcons["WALLET_POWER_UP"] = "wallet/steem/power-up";
    SVGIcons["WALLET_SP_DELEGATIONS"] = "wallet/hp/sp-delegations";
    SVGIcons["WALLET_RC_DELEGATIONS"] = "wallet/hp/rc-delegations";
    SVGIcons["WALLET_SAVINGS"] = "wallet/common/savings";
    SVGIcons["WALLET_CONVERT"] = "wallet/common/convert";
    SVGIcons["WALLET_SEND"] = "wallet/common/send";
    SVGIcons["WALLET_HISTORY_BUTTON"] = "wallet/common/history";
    SVGIcons["WALLET_TOKEN_DELEGATIONS"] = "wallet/tokens/delegations";
    SVGIcons["WALLET_TOKEN_STAKE"] = "wallet/tokens/stake";
    SVGIcons["WALLET_TOKEN_UNSTAKE"] = "wallet/tokens/unstake";
    SVGIcons["WALLET_TOKEN_GO_TO_DETAILED_PAGE"] = "wallet/tokens/go-to-detailed-page";
    SVGIcons["WALLET_TOKEN_PENDING_UNSTAKE_NEXT_TX"] = "wallet/tokens/pending-unstake/next-tx";
    SVGIcons["WALLET_TOKEN_PENDING_UNSTAKE_NEXT_TX_AMOUNT"] = "wallet/tokens/pending-unstake/next-tx-amount";
    SVGIcons["WALLET_HISTORY_FILTER_BUTTON"] = "wallet/history/filter-button";
    SVGIcons["WALLET_HISTORY_CLAIM_ACCOUNT"] = "wallet/history/claim-account";
    SVGIcons["WALLET_HISTORY_CLAIM_REWARDS"] = "wallet/history/claim-rewards";
    SVGIcons["WALLET_HISTORY_CONVERT"] = "wallet/history/convert";
    SVGIcons["WALLET_HISTORY_SP_DELEGATIONS"] = "wallet/history/sp-delegations";
    SVGIcons["WALLET_HISTORY_POWER_DOWN"] = "wallet/history/power-down";
    SVGIcons["WALLET_HISTORY_POWER_UP"] = "wallet/history/power-up";
    SVGIcons["WALLET_HISTORY_RC_DELEGATIONS"] = "wallet/history/rc-delegations";
    SVGIcons["WALLET_HISTORY_SAVINGS"] = "wallet/history/savings";
    SVGIcons["WALLET_HISTORY_TRANSFER"] = "wallet/history/transfer";
    SVGIcons["WALLET_HISTORY_TOKEN_DELEGATIONS"] = "wallet/history/token-delegations";
    SVGIcons["WALLET_HISTORY_STAKE"] = "wallet/history/stake";
    SVGIcons["WALLET_HISTORY_UNSTAKE"] = "wallet/history/unstake";
    SVGIcons["WALLET_HISTORY_EXPAND_COLLAPSE"] = "wallet/history/expand-collapse";
    SVGIcons["WALLET_HISTORY_TOP"] = "wallet/history/back-to-top";
    // LOGOS
    SVGIcons["BINANCE"] = "binance";
    SVGIcons["IONOMY"] = "ionomy";
    SVGIcons["GATEIO"] = "gateio";
    SVGIcons["HUOBI"] = "huobi";
    SVGIcons["MEXC"] = "mexc-global";
    SVGIcons["PROBIT"] = "probit";
    SVGIcons["TRANSAK"] = "transak";
    SVGIcons["UPBIT"] = "upbit";
})(SVGIcons || (SVGIcons = {}));
